var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$store.state.auth.me.app_region === 'US')?_c('Create_raw'):_c('Create_company_house')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }